import { Component, Inject, OnInit } from '@angular/core';
import { ModelsTransformUtil } from '@ddt-web/common';
import { APP_STORE_CONFIG_TOKEN, MODELS_STORE_NAME_TOKEN } from '@ddt-web/config';
import { AppStoreConfig } from '@ddt-web/data-service';
import { DialogConfig } from '@ddt-web/dialog';
import { StoreService } from '@ddt-web/store-service';
import * as get from 'lodash/get';
import * as has from 'lodash/has';
import * as set from 'lodash/set';
import { first } from 'rxjs/operators';

import { PortfolioFamily } from '../../../models/model-portfolio.interface';


@Component({
	selector: 'mp-models-screener-dialog',
	templateUrl: './models-screener-dialog.component.html',
	styleUrls: ['./models-screener-dialog.component.scss']
})
export class ModelsScreenerDialogComponent implements OnInit {
	public mode: string = '';
	public dialogWidth: string | number = '1000px';

	public allFamilies: PortfolioFamily[] = [];

	public isLoading: boolean = false;

	constructor(
		@Inject(APP_STORE_CONFIG_TOKEN) private storeConfig: AppStoreConfig,
		@Inject(MODELS_STORE_NAME_TOKEN) private modelStoreName: string,
		private storeService: StoreService,
		public config: DialogConfig
	) {
		this.mode = get(config.data, 'mode', this.mode);

		if (!has(config, 'style.width')) {
			// Set default width
			set(config, 'style.width', this.dialogWidth);
		}
	}

	public ngOnInit(): void {
		this.isLoading = true;
		this.storeService
			.selectAll(this.storeConfig[this.modelStoreName])
			.pipe(first(modelsConfig => Boolean(!modelsConfig.isLoading && modelsConfig.entities)))
			.subscribe(modelsConfig => {
				const configs = Object.values(modelsConfig.entities);
				const ids = get(modelsConfig, 'ids', []);
				if (configs) {
					const { defaultFamilies, additionalFamilies } = ModelsTransformUtil.transformModelPortfolios(configs, ids, true);
					this.allFamilies = [...(defaultFamilies || []), ...(additionalFamilies || [])];
				}
				this.isLoading = false;
			});
	}
}
